import axios from 'axios';

export const baseURL = window.env.REACT_APP_BACKEND_URL;

export const baseURLFile = window.env.REACT_APP_FILES_URL;

const api = axios.create({
  baseURL: `${baseURL}/api`,
});

const language = localStorage.getItem('i18nextLng');
const token = localStorage.getItem('token');

// eslint-disable-next-line dot-notation
api.defaults.headers.common['Authorization'] = token;

api.defaults.headers.common['Accept-Language'] = `${language}`;

export default api;
